import { Framework } from 'mage-deps/@klarna/mp-ui'
import PropTypes from 'prop-types'
import React from 'react'

import EnvironmentIdentifier from '../EnvironmentIdentifier'

const Unauthenticated = ({ footerConfig }) => {
  return (
    <>
      <EnvironmentIdentifier />
      <Framework
        isLoading
        footerConfig={{ text: footerConfig.text }}
      />
    </>
  )
}

Unauthenticated.propTypes = {
  footerConfig: PropTypes.object
}

export default Unauthenticated
